/**
 * Created by Carsten Hibbeler on 15.02.2016.
 */
'use strict';

import warning from './warning';

/**
 *
 * @param o
 * @returns {Array|*}
 */

function isObject(o) {
    return typeof o === 'object' && !Array.isArray(o);
}

export function getClassName(data) {
    return data && data.className;
}

export function asObject(data) {
    return data && (data.hasOwnProperty('item') ? data.item : data);
}

export function asArray(data) {
    const d = asObject(data);
    warning(!d || Array.isArray(d), 'Array or DataList expected %s', data);
    return d;
}

export function asItem(data) {
    const d = asObject(data);

    warning((d && d.id) || !data || (data && (data._invalid || data._loading || data._error)), 'item invalid and no id but properties!', data);
    warning(!d || isObject(d), 'object or DataItem expected %s', data);

    return d;
}

export function idMap(data, propName) {

    if (propName) {
        console.error('Propname is used!');
        //debugger;
    }

    const map = {};
    if (data) {
        const item = asObject(data);
        if (item) {
            if (Array.isArray(item)) {
                item.forEach(i => {
                    const id = propName ? i[ propName ] : i.id;
                    if (id) {
                        map[ id ] = true;
                    }
                    else {
                        map[ i ] = true;
                    }
                });
            } else {
                const id = propName ? item[ propName ] : item.id;
                if(id) {
                    map[ id ] = true;
                }
            }
        }
    }
    return map;
}





// WEBPACK FOOTER //
// ./js/utils/data-util.js